import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { HdRelationInfoService, HdRelationInfoTopic } from './hd-relation-info.service';

/** Paneel-data: het relatieboek-onderwerp dat dit paneel toont. */
export interface HdRelationInfoPanelData {
  readonly topic: HdRelationInfoTopic;
}

/**
 * Gedockt/zwevend info-paneel met relatieboek-content (composite charts).
 * Rendert het markdown-document van het gevraagde topic in de actieve
 * contenttaal; wisselt live mee met de taal-switch.
 */
@Component({
  selector: 'hd-relation-info-panel',
  standalone: true,
  imports: [MarkdownComponent],
  templateUrl: './hd-relation-info-panel.component.html',
  styleUrl: './hd-relation-info-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdRelationInfoPanelComponent {
  private readonly panelData = inject(FLOATING_PANEL_DATA, { optional: true }) as
    Signal<HdRelationInfoPanelData | null> | null;
  private readonly relationInfo = inject(HdRelationInfoService);

  protected readonly markdownUrl = computed<string | null>(() => {
    const topic = this.panelData?.()?.topic;
    if (topic == null) {
      return null;
    }
    return this.relationInfo.relationMarkdownUrl(topic);
  });
}
